module.exports = __webpack_public_path__ + "assets/images/923455be1f667836547cad3dc57148eb.svg";


//////////////////
// WEBPACK FOOTER
// ./src/static/images/icons/twitter.svg
// module id = 731
// module chunks = 0